/*!

=========================================================
* Vue Argon Dashboard - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import ArgonDashboard from './plugins/argon-dashboard'
import moment from 'moment';
import { Auth0Plugin } from "./auth";
import axios from 'axios';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
Vue.use(Loading);

Vue.config.productionTip = false
Vue.prototype.$http = axios

Vue.use(Auth0Plugin, {
  domain: process.env.VUE_APP_AUTH0_CONFIG_DOMAIN,
  clientId: process.env.VUE_APP_AUTH0_CONFIG_CLIENT_ID,
  onRedirectCallback: appState => {
    router.push(
      appState && appState.targetUrl
        ? appState.targetUrl
        : window.location.pathname
    );
  }
});


Vue.use(ArgonDashboard);
Vue.use(moment);
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
